import { difference, isEmpty, isEqual, omitBy, pickBy } from "lodash";
import { useRef } from "react";
import { FilterInfo } from "types/pagination";

export default function useDetectFilterChange(
  filterInfo: FilterInfo,
): FilterInfo {
  const oldFilterRef = useRef<FilterInfo>({});

  const hasEmptyFilters = Object.keys(pickBy(filterInfo, isEmpty)).length;
  const omitedFilterInfo = hasEmptyFilters
    ? omitBy(filterInfo, isEmpty)
    : filterInfo;

  if (oldFilterRef.current === filterInfo) {
    // nothing changed, probably called due to rerender
    return oldFilterRef.current;
  }

  const oldKeys = Object.keys(oldFilterRef.current);
  const newKeys = Object.keys(omitedFilterInfo);
  if (
    oldKeys.length !== newKeys.length ||
    difference(oldKeys, newKeys).length > 0 ||
    difference(newKeys, oldKeys).length > 0
  ) {
    oldFilterRef.current = omitedFilterInfo;
    return omitedFilterInfo;
  }

  // here it means all keys are same but values has changed
  for (let i = 0; i < newKeys.length; i++) {
    if (
      !isEqual(omitedFilterInfo[newKeys[i]], oldFilterRef.current[newKeys[i]])
    ) {
      oldFilterRef.current = omitedFilterInfo;
      return omitedFilterInfo;
    }
  }
  return oldFilterRef.current;
}
